/* eslint-disable sort-keys */
/* eslint-disable max-lines */
import {File} from 'models';
import {TASTING_CERTIFICATE_BUTTON_LINK_HREF} from 'modules/events/components/BannerCertificateModal/constants';
import {IProduct} from 'modules/product-card/models/ProductResponse';

export const IS_DEV = 'development' === process.env.NODE_ENV;

export const APP_VERSION = '1.0.0';

export const APP_BUILD_VERSION = '1';

export const INVALIDATE_USER_CACHE = 'invalidate_user_cache';

export const DEBOUNCE_DELAY = 400;
export const DEBOUNCE_DELAY_SECOND = 1000;

export const MOBILE_HEADER_MAX_WIDTH = 1023;
export const MOBILE_MAX_WIDTH = 1279;

export const TABLET_MAX_WIDTH = 768;
export const TABLET_MD_WIDTH = 1024;
export const MIN_DESKTOP_WIDTH = 1440;

export const AVAILABILITY_DELIVERY_TEXT = {
    availability: 'Наличие',
    delivery: 'Доставка',
    pickup: 'Самовывоз',
    reportReceipt: 'Сообщить о поступлении',
    whereIsInTheShop: 'Где этот товар в магазине?',
} as const;

export const TOAST_CLOSE_TIME = 3000;

export const PAGINATION_PARAM = 'page-number';

export const REDIRECT_PARAM = 'r';
export const REDIRECT_PARAM_VALUE = 'sameVintage';

export type TWebVitalsName = 'CLS' | 'FCP' | 'FID' | 'LCP' | 'TTFB';

export type TWebVitalsMetric = {
    name: TWebVitalsName;
    [key: string]: any;
};

export type TWebVitalsBenchmark = Record<
    TWebVitalsName,
    {
        max: number;
        min: number;
    }
>;

export const MAX_COUNTER_VALUE = 300;
export const MIN_COUNTER_VALUE = 0;
export const MAX_COUNT_DISPLAY = 9999;

export const PRICE_DENOMINATOR = 100;
export const BONUS_DENOMINATOR = 100;

export const SECOND = 1000;

export const SECONDS_PER_MINUTE = 60;

export const SECONDS_PER_HOUR = 3600;

export const PREVENT_DEFAULT_HANDLER_MARKER = 'data-prevent-default-marker';

export const STOP_PROP_HANDLER_MARKER = 'data-stop-propagation-marker';

export const SHOP_LINK = 'https://shop.ru';

export const PERSONAL_DATA_LINK = `${SHOP_LINK}/rules/accept/`;

export const SELLING_RULES_LINK = `${SHOP_LINK}/rules/about/`;

export const WISH_LISTS_LINK = `${SHOP_LINK}/personal/list/`;

export const SUPPORT_FORM_LINK = `${SHOP_LINK}/#small-dialog-error`;

export const LAYOUT_SHIFTING_TRANSITION_PROP_NAMES = [
    'height',
    'width',
    'max-height',
    'max-width',
    'min-height',
    'min-width',
    'padding',
    'margin',
] as const;

export const RUNTIME_CSS_VARS_DEFAULT_VALUES = {
    menuTop: 104,
    menuTopCollapsed: 72,
};

/**
 * Ref: src/styles/normalize.scss
 */
export const RUNTIME_CSS_VARS = {
    bottomBarHeight: '--bottom-bar-height',
    calcModalTitleHeight: '--calc-modal-title-height',
    fixedHeaderContentMarginTop: '--content-margin-top',
    menuTop: '--menu-top',
    productBuyMobilePanelHeight: '--product-buy-mobile-panel-height',
    productCardFixedHeader: '--product-card-fixed-header',
    viewPortHeight: '--view-port-height',
} as const;

export const FORCE_RELOAD_GET_PARAM = 'reload';

export const REDIRECT_REQUEST_COOKIE_NAME = '__redirect-me-to';

export const TODAY = 'Сегодня';
export const UNDERSTAND = 'Понятно';

export const HIDE = 'Скрыть';

// TODO: править, когда актуализируют модель, удалить | 'image/jpeg' | 'image/png
export const MIME_TYPES: Record<
    'doc' | 'jpg' | 'pdf' | 'png',
    Extract<File['mimetype'], 'application/msword' | 'application/pdf'> | 'image/jpeg' | 'image/png'
> = {
    doc: 'application/msword',
    jpg: 'image/jpeg',
    pdf: 'application/pdf',
    png: 'image/png',
};

export const MAX_PRODUCTS_AMOUNT = 50_000;

export const ARROW_DIRECTION = {
    down: 'down',
    left: 'left',
    right: 'right',
    up: 'up',
} as const;

// TODO: удалить после интеграции категорий

export const MOCK_CATEGORIES = [
    {
        href: 'https://simplewine.ru/stock/beautiful-words/',
        id: 1,
        name: 'В подарок',
        isMarked: true,
    },
    {
        href: '/catalog/vino/',
        id: 2,
        name: 'Вино',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/',
        id: 3,
        name: 'Шампанское и игристое',
    },
    {
        href: '/catalog/ksn/viski/',
        id: 4,
        name: 'Виски',
    },
    {
        href: '/catalog/ksn/konyak/',
        id: 5,
        name: 'Коньяк',
    },
    {
        href: '/catalog/ksn/',
        id: 6,
        name: 'Крепкие напитки',
    },
    {
        href: '/catalog/voda_i_soki/',
        id: 7,
        name: 'Вода',
    },
    {
        href: '/catalog/steklo/',
        id: 8,
        name: 'Бокалы',
    },
    {
        href: '/catalog/aksessuary/',
        id: 9,
        name: 'Аксессуары',
    },
    {
        href: '/catalog/fineandrare/',
        id: 10,
        name: 'Fine & Rare',
    },
    {
        href: '/articles/',
        id: 11,
        name: 'Блог',
    },
    {
        href: '/events/',
        id: 12,
        name: 'Дегустации',
    },
    {
        code: 'sale',
        href: '/stock/discount/',
        id: 13,
        name: 'Акции %',
    },
];

export const MOCK_MENU_CATEGORIES = [
    {
        categories: [
            {
                name: 'Все',
                url: '/catalog/vino/',
                code: 'vino',
            },
            {
                name: 'Сухое',
                url: '/catalog/vino/filter/sugar_type-sukhoe/',
                code: 'vino-sugar_type-sukhoe',
            },
            {
                name: 'Полусухое',
                url: '/catalog/vino/filter/sugar_type-polusukhoe/',
                code: 'vino-sugar_type-polusukhoe',
            },
            {
                name: 'Полусладкое',
                url: '/catalog/vino/filter/sugar_type-polusladkoe/',
                code: 'vino-sugar_type-polusladkoe',
            },
            {
                name: 'Сладкое',
                url: '/catalog/vino/filter/sugar_type-sladkoe/',
                code: 'vino-sugar_type-sladkoe',
            },
            {
                name: 'Красное',
                url: '/catalog/vino/filter/color-krasnoe/',
                code: 'vino-krasnoe',
            },
            {
                name: 'Белое',
                url: '/catalog/vino/filter/color-beloe/',
                code: 'vino-beloe',
            },
            {
                name: 'Розовое',
                url: '/catalog/vino/filter/color-rozovoe/',
                code: 'vino-rozovoe',
            },
            {
                name: 'Оранжевое',
                url: '/catalog/vino/filter/orange-1/',
                code: 'vino-orange-1',
            },
            {
                name: 'Органика',
                url: '/catalog/vino/filter/cultivation_type-organika/',
                code: 'vino-cultivation_type-organika',
            },
            {
                name: 'Биодинамика',
                url: '/catalog/vino/filter/cultivation_type-biodinamika/',
                code: 'cultivation_type-biodinamika',
            },
            {
                name: 'Sustainable',
                url: '/catalog/vino/filter/cultivation_type-sustainable/',
                code: 'vino-cultivation_type-sustainable',
            },
        ],
        name: 'Вино',
        code: 'vino',
    },
    {
        categories: [
            {
                name: 'Все',
                url: '/catalog/shampanskoe_i_igristoe_vino/',
                code: 'shampanskoe_i_igristoe_vino',
            },
            {
                name: 'До 1 000 Р',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/main-to-1000/',
                code: 'shampanskoe_i_igristoe_vino-shampanskoe_i_igristoe_vino-price-0-1000',
            },
            {
                name: 'От 1 000 до 3 000 Р',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-1000-to-3000/',
                code: 'shampanskoe_i_igristoe_vino-ot-1000-do-3000',
            },
            {
                name: 'Шампанское',
                url: '/catalog/shampanskoe_i_igristoe_vino/shampanskoe/',
                code: 'shampanskoe_i_igristoe_vino-shampanskoe_i_igristoe_vino-champagne',
            },
            {
                name: 'Просекко',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/country-italiya/appellason-prosecco_doc-or-prosecco_valdobbiadene_superiore_docg/grape-glera/',
                code: 'shampanskoe_i_igristoe_vino-shampanskoe_i_igristoe_vino_type_prosecco',
            },
            {
                name: 'Креман',
                url: '/catalog/shampanskoe_i_igristoe_vino/igristoe-vino/filter/appellason-cremant_d_alsace_aoc-or-cremant_de_bourgogne_aoc-or-cremant_de_limoux_aoc-or-cremant_de_limoux_aop-or-montlouis_sur_loire_aoc-or-saumur_aoc/',
                code: 'shampanskoe_i_igristoe_vino-shampanskoe_i_igristoe_vino_type_cremant',
            },
            {
                name: 'Кава',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/appellason-cava_do/',
                code: 'shampanskoe_i_igristoe_vino-shampanskoe_i_igristoe_vino_type_cava',
            },
            {
                name: 'Асти',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/appellason-asti_docg/',
                code: 'shampanskoe_i_igristoe_vino-shampanskoe_i_igristoe_vino_type_asti',
            },
            {
                name: 'Франчакорта',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/country-italiya/appellason-franciacorta_docg/',
                code: 'shampanskoe_i_igristoe_vino-shampanskoe_i_igristoe_vino_type_franciacorta',
            },
            {
                name: 'Brimoncourt',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-brimoncourt/',
                code: 'shampanskoe_i_igristoe_vino-brimoncourt',
            },
            {
                name: 'Bruni',
                url: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-bruni/',
                code: 'shampanskoe_i_igristoe_vino-bruni',
            },
        ],
        name: 'Шампанское и игристое',
        code: 'shampanskoe_i_igristoe_vino',
    },
    {
        categories: [
            {
                name: 'Все',
                url: '/catalog/ksn/viski/',
                code: 'viski',
            },
            {
                name: 'Bellevoye',
                url: '/catalog/ksn/filter/manufacturer-bellevoye/',
                code: 'viski-bellevoye',
            },
            {
                name: 'Black Bottle',
                url: '/catalog/ksn/viski/filter/manufacturer-black_bottle/',
                code: 'viski-black_bottle',
            },
            {
                name: 'Bunnahabhain',
                url: '/catalog/ksn/viski/filter/manufacturer-bunnahabhain/',
                code: 'viski-bunnahabhain',
            },
            {
                name: 'Chivas',
                url: '/catalog/ksn/viski/filter/manufacturer-chivas_brothers/',
                code: 'viski-chivas_brothers',
            },
            {
                name: 'Deanston',
                url: '/catalog/ksn/viski/filter/manufacturer-deanston/',
                code: 'viski-deanston',
            },
            {
                name: 'Glengoyne',
                url: '/catalog/ksn/viski/filter/manufacturer-glengoyne/',
                code: 'viski-glengoyne',
            },
            {
                name: 'Jameson',
                url: '/catalog/ksn/viski/filter/manufacturer-jameson/',
                code: 'viski-jameson',
            },
            {
                name: 'Macallan',
                url: '/catalog/ksn/viski/filter/manufacturer-macallan/',
                code: 'viski-macallan',
            },
            {
                name: `Michter's`,
                url: '/catalog/ksn/viski/filter/manufacturer-michter_s_distillery/',
                code: 'viski-michter_s_distillery',
            },
            {
                name: 'Nikka',
                url: '/catalog/ksn/viski/filter/manufacturer-nikka/',
                code: 'viski-nikka',
            },
            {
                name: 'Tamdhu',
                url: '/catalog/ksn/viski/filter/manufacturer-tamdhu/',
                code: 'viski-tamdhu',
            },
            {
                name: 'The Irishman',
                url: '/catalog/ksn/viski/filter/manufacturer-the_irishman/',
                code: 'viski-the_irishman',
            },
            {
                name: 'Togouchi',
                url: '/catalog/ksn/viski/filter/manufacturer-togouchi/',
                code: 'viski-togouchi',
            },
            {
                name: `Writers’ Tears`,
                url: '/catalog/ksn/filter/manufacturer-writers_tears/',
                code: 'viski-writers_tears',
            },
            {
                name: 'Шотландия',
                url: '/catalog/ksn/viski/filter/country-shotlandiya/',
                code: 'viski-shotlandiya',
            },
            {
                name: 'Ирландия',
                url: '/catalog/ksn/viski/filter/country-irlandiya/',
                code: 'viski-irlandiya',
            },
            {
                name: 'Франция',
                url: '/catalog/ksn/viski/filter/country-frantsiya/',
                code: 'viski-frantsiya',
            },
            {
                name: 'Япония',
                url: '/catalog/ksn/viski/filter/country-yaponiya/',
                code: 'viski-yaponiya',
            },
            {
                name: 'США',
                url: '/catalog/ksn/viski/filter/country-soedinennye_shtaty_ameriki/',
                code: 'viski-ssha',
            },
            {
                name: 'До 1 000 ₽ ',
                url: '/catalog/ksn/viski/filter/main-to-1000/',
                code: 'viski-do-1000',
            },
            {
                name: 'От 1 000 до 3 000 ₽',
                url: '/catalog/ksn/viski/filter/main-from-1000-to-3000/',
                code: 'viski-ot-1000-do-3000',
            },
            {
                name: 'От 3 000 до 6 000 ₽',
                url: '/catalog/ksn/viski/filter/main-from-3000-to-6000/',
                code: 'viski-ot-3000-do-6000',
            },
            {
                name: 'От 6 000 до 10 000 ₽',
                url: '/catalog/ksn/viski/filter/main-from-6000-to-10000/',
                code: 'viski-ot-6000-do-10000',
            },
            {
                name: 'От 10 000 до 20 000 ₽',
                url: '/catalog/ksn/viski/filter/main-from-10000-to-20000/',
                code: 'viski-ot-10000-do-20000',
            },
            {
                name: 'От 20 000 ₽',
                url: '/catalog/ksn/viski/filter/main-from-20000/',
                code: 'viski-ot-20000',
            },
        ],
        name: 'Виски',
        url: '/',
        code: 'viski',
    },
    {
        categories: [
            {
                name: 'Все',
                url: '/catalog/ksn/konyak/',
                code: 'konyak',
            },
            {
                name: 'Camus',
                url: '/catalog/ksn/konyak/filter/manufacturer-camus/',
                code: 'konyak-manufacturer-camus',
            },
            {
                name: 'Davidoff',
                url: '/catalog/ksn/konyak/filter/manufacturer-davidoff/',
                code: 'konyak-manufacturer-davidoff',
            },
            {
                name: 'Frapin',
                url: '/catalog/ksn/konyak/filter/manufacturer-frapin/',
                code: 'konyak-manufacturer-frapin',
            },
            {
                name: 'Hine',
                url: '/catalog/ksn/filter/manufacturer-hine/',
                code: 'konyak-manufacturer-hine',
            },
            {
                name: 'Monnet',
                url: '/catalog/ksn/konyak/filter/manufacturer-monnet/',
                code: 'konyak-manufacturer-monnet',
            },
            {
                name: 'VS',
                url: '/catalog/ksn/konyak/filter/konyak_class-v_s/',
                code: 'konyak-konyak_class-v_s',
            },
            {
                name: 'VSOP',
                url: '/catalog/ksn/konyak/filter/konyak_class-v_s_o_p/',
                code: 'konyak-vsop',
            },
            {
                name: 'XO',
                url: '/catalog/ksn/konyak/filter/konyak_class-extra-or-x_o/',
                code: 'konyak_class-extra-or-x_o',
            },
            {
                name: 'От 10 000 до 20 000 ₽',
                url: '/catalog/ksn/konyak/filter/main-from-10000-to-20000/',
                code: 'konyak-ot-10000-do-20000',
            },
            {
                name: 'От 20 000 ₽',
                url: '/catalog/ksn/konyak/filter/main-from-20000/',
                code: 'konyak-ot-20000',
            },
        ],
        name: 'Коньяк',
        url: '/',
        code: 'konyak',
    },
    {
        categories: [
            {
                name: 'Все',
                url: '/catalog/ksn/',
                code: 'ksn',
            },
            {
                name: 'От 20 000 ₽',
                url: '/catalog/ksn/filter/main-from-20000/',
                code: 'ksn--ot-20000',
            },
            {
                name: 'Джин',
                url: '/catalog/ksn/dzhin/',
                code: 'spirits_type_gin',
            },
            {
                name: 'Ром',
                url: '/catalog/ksn/rom/',
                code: 'spirits_type_rom',
            },
            {
                name: 'Водка',
                url: '/catalog/ksn/vodka/',
                code: 'spirits_type_vodka',
            },
            {
                name: 'Арманьяк',
                url: '/catalog/ksn/armanyak/',
                code: 'spirits_type_armanyak',
            },
            {
                name: 'Бренди',
                url: '/catalog/ksn/brendi/',
                code: 'spirits_type_brendi',
            },
            {
                name: 'Ликер',
                url: '/catalog/ksn/liker/',
                code: 'ksn-liker',
            },
            {
                name: 'Текила',
                url: '/catalog/ksn/tekila/',
                code: 'ksn-spirits_type_tekila',
            },
            {
                name: 'Вермут',
                url: '/catalog/ksn/vermut/',
                code: 'ksn-vermut',
            },
            {
                name: 'Саке',
                url: '/catalog/ksn/sake/',
                code: 'spirits_type_sake',
            },
            {
                name: 'Настойка',
                url: '/catalog/ksn/nastoyki/',
                code: 'ksn-nastoyki',
            },
            {
                name: 'Bunnahabhain',
                url: '/catalog/ksn/filter/manufacturer-bunnahabhain/',
                code: 'ksn-bunnahabhain-1',
            },
            {
                name: 'Angostura',
                url: '/catalog/ksn/filter/manufacturer-angostura/',
                code: 'ksn-angostura',
            },
        ],
        name: 'Крепкие напитки',
        url: '/',
        code: 'ksn',
    },
    {
        categories: [
            {
                name: 'Все',
                url: '/catalog/voda_i_soki/',
                code: 'voda_i_soki',
            },
            {
                name: 'Минеральная вода',
                url: '/catalog/voda_i_soki/mineralnaya_voda/',
                code: 'voda_i_soki-mineralnaya-voda',
            },
            {
                name: 'Соки',
                url: '/catalog/voda_i_soki/soki/',
                code: 'voda_i_soki-soki',
            },
            {
                name: 'Сиропы',
                url: '/catalog/voda_i_soki/siropy/',
                code: 'voda_i_soki-siropy',
            },
            {
                name: 'До 1 000 ₽',
                url: '/catalog/voda_i_soki/filter/main-to-1000/',
                code: 'voda_i_soki-do-1000',
            },
            {
                name: 'От 1 000 до 3 000 ₽',
                url: '/catalog/voda_i_soki/filter/main-from-1000-to-3000/',
                code: 'voda_i_soki-ot-1000-do-3000',
            },
            {
                name: 'Газированная',
                url: '/catalog/voda_i_soki/filter/drink_type-gazirovannaya/',
                code: 'voda_i_soki-gazirovannaya',
            },
            {
                name: 'Негазированная',
                url: '/catalog/voda_i_soki/mineralnaya_voda/filter/drink_type-negazirovannaya/',
                code: 'voda_i_soki-negazirovannaya',
            },
            {
                name: 'Италия',
                url: '/catalog/voda_i_soki/filter/country-italiya/',
                code: 'voda_i_soki-country-italiya',
            },
            {
                name: 'Грузия',
                url: '/catalog/voda_i_soki/filter/country-gruziya/',
                code: 'voda_i_soki-country-gruziya',
            },
            {
                name: 'Норвегия',
                url: '/catalog/voda_i_soki/filter/country-norvegiya/',
                code: 'voda_i_soki-country-norvegiya',
            },
            {
                name: 'Россия',
                url: '/catalog/voda_i_soki/filter/country-rossiya/',
                code: 'voda_i_soki-country-rossiya',
            },
            {
                name: 'San Benedetto',
                url: '/catalog/voda_i_soki/filter/manufacturer-san_benedetto/',
                code: 'voda_i_soki-san_benedetto',
            },
            {
                name: 'VOSS',
                url: '/catalog/voda_i_soki/filter/manufacturer-voss/',
                code: 'voda_i_soki-voss',
            },
            {
                name: 'Aqua Russa',
                url: '/catalog/voda_i_soki/filter/manufacturer-aqua_russa/',
                code: 'voda_i_soki-aqua_russa',
            },
            {
                name: 'Все бренды',
                url: '/catalog/voda_i_soki/',
                code: 'voda_i_soki-vse-brandy',
            },
            {
                name: '0,25 - 0,5 л',
                url: '/catalog/voda_i_soki/filter/volume-0_2-or-0_25-or-0_33-or-0_375-or-0_5/',
                code: 'voda_i_soki-0-5-l',
            },
            {
                name: '0,65 - 0,8 л',
                url: '/catalog/voda_i_soki/filter/volume-0_65-or-0_75-or-0_8/',
                code: 'voda_i_soki-volume-0-65-0-8-l',
            },
            {
                name: '1 - 1,5 л',
                url: '/catalog/voda_i_soki/filter/volume-1-or-1_5/',
                code: 'voda_i_soki-1-1-5-l',
            },
        ],
        name: 'Вода',
        url: '/',
        code: 'voda_i_soki',
    },
    {
        categories: [
            {
                name: 'Все',
                url: '/catalog/steklo/',
                code: 'steklo',
            },
            {
                name: 'От 3 000 до 6 000 ₽',
                url: '/catalog/steklo/filter/main-from-3000-to-6000/',
                code: 'steklo-ot-3000-do-6000',
            },
            {
                name: 'из 2 бокалов',
                url: '/catalog/steklo/nabory/nabory_iz_2_kh_bokalov/',
                code: 'steklo-iz-2-bokalov',
            },
            {
                name: 'из 4 бокалов',
                url: '/catalog/steklo/nabory/nabory_iz_4_kh_bokalov/',
                code: 'steklo-iz-4-bokalov',
            },
            {
                name: 'из 6 бокалов',
                url: '/catalog/steklo/nabory/nabory_iz_6_ti_bokalov/',
                code: 'steklo-iz-6-bokalov',
            },
            {
                name: 'Spiegelau',
                url: '/catalog/steklo/filter/manufacturer-spiegelau/',
                code: 'steklo-spiegelau',
            },
            {
                name: 'Zalto',
                url: '/catalog/steklo/filter/manufacturer-zalto/',
                code: 'steklo-zalto',
            },
        ],
        name: 'Бокалы',
        url: '/',
        code: 'steklo',
    },
    {
        categories: [
            {
                name: 'Все подарки',
                url: 'https://simplewine.ru/stock/beautiful-words',
                code: '/stock/beautiful-words',
            },
            {
                name: 'Тихие вина',
                url: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-vino',
                code: '/filter_category-vino',
            },
            {
                name: 'Шампанское и игристое',
                url: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-shampanskoe_i_igristoe',
                code: '/filter_category-shampanskoe_i_igristoe',
            },
            {
                name: 'Виски',
                url: 'https://simplewine.ru/stock/beautiful-words/filter/filter_category-viski/?tabId[]=viski-beautiful-words',
                code: '/filter_category-viski/?tabId[]=viski-beautiful-words',
            },
            {
                name: 'Коньяк',
                url: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=konyak-beautiful-words',
                code: '.?tabId[]=konyak-beautiful-words',
            },
            {
                name: 'Крепкие напитки',
                url: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=krepkie-napitki-beautiful-words',
                code: '.?tabId[]=krepkie-napitki-beautiful-words',
            },
            {
                name: 'Бокалы и аксессуары',
                url: 'https://simplewine.ru/stock/beautiful-words/?tabId[]=bokaly-i-aksessuary-beautiful-words',
                code: '/?tabId[]=bokaly-i-aksessuary-beautiful-words',
            },
        ],
        name: 'В подарок',
        url: 'https://simplewine.ru/stock/beautiful-words/',
        code: 'v-podarok',
        isMarked: true,
    },
    {
        categories: [],
        name: 'Подарочные сертификаты',
        url: TASTING_CERTIFICATE_BUTTON_LINK_HREF,
        code: 'podarochnye-sertifikaty-1',
    },
    {
        categories: [],
        name: 'Аксессуары',
        url: '/catalog/aksessuary/',
        code: 'aksessuary',
    },
    {
        categories: [],
        name: 'Fine & Rare',
        url: '/catalog/fineandrare/',
        code: 'Fine&Rare',
    },
    {
        categories: [],
        name: 'Блог',
        url: '/articles/',
        code: 'blog',
    },
    {
        categories: [],
        name: 'Дегустации',
        url: '/events/',
        code: 'events',
    },
    {
        categories: [],
        code: 'promos',
        name: 'Акции',
        url: 'https://simplewine.ru/stock/discount/',
    },
];

// TODO: добавить домены в env
export const MENU_SERVICES = [
    {
        name: 'Сервис SimplePrivé',
        url: 'https://simplewine.ru/prive/',
        dataAutotestTarget: 'header',
        dataAutotestTargetId: 'header-link-prive',
        isPrive: true,
    },
    {
        name: 'Корпоративным клиентам',
        url: 'https://simplewine.ru/corp/',
        dataAutotestTarget: 'header',
        dataAutotestTargetId: 'header-link-corp',
    },
    {
        name: 'Ресторанам, магазинам, дистрибьюторам',
        url: 'https://b2b.simple.ru/login',
        dataAutotestTarget: 'header',
        dataAutotestTargetId: 'header-link-b2b',
    },
    {
        name: 'Франшиза винных бутиков',
        url: 'https://simple.ru/services/franchise/',
        dataAutotestTarget: 'header',
        dataAutotestTargetId: 'header-link-franchise',
    },
];

export const STATUS_CODES = {
    BAD_REQUEST: 400,
    INTERNAL_SERVER_ERROR: 500,
    NOT_FOUND: 404,
    SERVICE_UNAVAILABLE: 503,
    UNAUTHORIZED: 401,
    UNPROCESSABLE_ENTITY: 422,
};

export const PRICE_STYLE = {
    currency: 'currency',
} as const;

export const PI = 3.14;

export const WORKERS_GROUP_INDEXES = [39, 40, 41, 42, 43, 8, 9, 10, 11];

export const SIMPLE_DOMAIN_GENERAL_MASK = '.simplewine.ru';

export const PHONE_NUMBERS_LENGTH = 11;

export const FORM_ERRORS = {
    COMMON: {
        REQUIRED: 'Поле обязательно для заполнения',
    },
    EMAIL: {
        FORMAT: 'Введите корректный e-mail',
    },
    PHONE: {
        FORMAT: 'Введите корректный номер телефона',
    },
};

export const WEEK_DAY_SORTED_LIST = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const MONTH_SORTED_LIST = [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь',
];

export const MONTH_SORTED_LIST_GENITIVE = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];

export const DAYS_OF_WEEK_LIST = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];

export const DAYS_OF_WEEK_SHORT_LIST = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

export const PRIVACY_EMAIL_HREF = 'mailto:privacy@simple.ru';
export const INFO_EMAIL_HREF = 'mailto:info@simple.ru';

export const IS_PROD = 'production' === process.env.NODE_ENV;

export const PRODUCT_PLACEHOLDER: IProduct = {
    offerId: 174043,
    masterArticle: '136589',
    article: '136589',
    staticUnifier: '80405',
    title: 'Штопор  Chef Sommelier',
    name: 'Штопор  Chef Sommelier',
    url: '/catalog/product/l_atelier_du_vin___136589/',
    sections: [
        {
            id: 126,
            code: 'shtopory',
            title: 'Штопоры',
            isTop: false,
            isCanonical: false,
            parent: {
                id: 111,
                code: 'aksessuary',
                title: 'Аксессуары',
                isTop: true,
                isCanonical: false,
            },
        },
    ],
    reviewsCount: 7,
    ratings: [
        {
            code: 'REVIEWS',
            value: 4.6,
            title: 'Рейтинг SimpleWine',
        },
    ],
    media: {
        imagePreview: '/upload/iblock/c74/c743b25550d1afbac55376ae96fff29f.jpg',
        images: [
            '/upload/iblock/cd1/cd10c82933019e69d075136cd7755f9e.jpg',
            '/upload/iblock/2a6/2a6c3ea37eac995ecf46144faa6a3458.jpg',
        ],
    },
    price: {
        base: {
            price: 4290,
            currency: 'RUB',
        },
        piece: {
            price: 3218,
            currency: 'RUB',
        },
        discount: {
            price: 3218,
            currency: 'RUB',
            discountType: 'PERCENT',
            discountValue: 25,
        },
        cashback: null,
        specPrice: null,
        isSpecPrice: false,
        hasEcomRule: false,
        showDiscountPercent: true,
    },
    properties: [
        {
            code: 'year',
            title: 'Год',
            type: 'int',
            value: 0,
        },
        {
            code: 'netVolume',
            title: 'Объем',
            type: 'float',
            value: 0,
        },
        {
            code: 'country',
            title: 'Страна',
            type: 'object',
            value: {
                id: 'ФРА',
                slug: 'frantsiya',
                value: 'Франция',
            },
        },
        {
            code: 'color',
            title: 'Цвет',
            type: 'object',
            value: {
                id: 'СТАЛЬ/ДЕРЕВО',
                slug: 'nerzh_stal_derevo',
                value: 'нерж.сталь/дерево',
            },
        },
        {
            code: 'grapeContent',
            title: 'Виноград',
            type: 'array<object>',
            value: [],
        },
        {
            code: 'alcohol',
            title: 'Алкогольный или нет',
            type: 'int',
            value: 0,
        },
        {
            code: 'fineRareItem',
            title: 'Является ли F&R',
            type: 'bool',
            value: false,
        },
        {
            code: 'manufacturer',
            title: 'Производитель',
            type: 'object',
            value: {
                id: 'Б13',
                slug: 'l_atelier_du_vin',
                value: "Л'Ателье дю Ван",
                translate: "L'Atelier du Vin",
            },
        },
        {
            code: 'art',
            title: 'Признак, что товар является постоянным ассортиментом какой-то постоянной подборки',
            type: 'bool',
            value: false,
        },
    ],
    labels: [
        {
            code: 'IN_STOCK',
            title: 'Участвует в акции',
            saleTitle: 'В отражении вашего лета',
            url: '/stock/v-otrazhenii-vashego-leta/',
        },
    ],
    qtyPerUOM: 1,
    description: 'Франция, нерж.сталь/дерево',
    canBuy: true,
    canReserve: true,
} as unknown as IProduct;

export const RUB_SYMBOL = '₽';
